import { datadogLogs } from "@datadog/browser-logs";
import { getApiClient } from "./API";

const queryString = (query) => {
  if (typeof query === "string") {
    return query.replace("?", "");
  }
  return Object.entries(query)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join("&");
};

const formService = {
  async currentFormServiceUser() {
    const response = await getApiClient().get("/forms/current");
    const user = response.data;
    user["x-jwt-token"] = response.headers["x-jwt-token"];
    return user;
  },

  async getSchema(form) {
    return (await getApiClient().get(`/forms/${form}`)).data;
  },

  async getSubmission(form, id) {
    return (await getApiClient().get(`/forms/${form}/submission/${id}`)).data;
  },

  async updateSubmission(form, id, payload) {
    try {
      return (await getApiClient().put(`/forms/${form}/submission/${id}`, payload)).data;
    } catch (error) {
      const data = {
        id: id ?? undefined,
        application_id: payload?.data?.application_id,
        form: form ?? undefined,
      };
      datadogLogs.logger.error("Error while updating submission to form.io", { data: data }, error);
      throw error; // don't let datadog logging stop error from propagating to downstream handlers
    }
  },

  async partiallyUpdateSubmission(form, id, payload) {
    return (await getApiClient().patch(`/forms/${form}/submission/${id}`, payload)).data;
  },

  async listSubmissions(form, query = { limit: 200, sort: "-created" }) {
    return (await getApiClient().get(`/forms/${form}/submission?${queryString(query)}`)).data;
  },

  async submissionExists(form, query) {
    return (await getApiClient().get(`/forms/${form}/exists?${queryString(query)}`)).data;
  },

  async validateSubmission(form, payload) {
    return (await getApiClient().post(`/forms/${form}/validate`, payload)).data;
  },

  async createSubmission(form, payload) {
    try {
      return (await getApiClient().post(`/forms/${form}/submission`, payload)).data;
    } catch (error) {
      const data = {
        application_id: payload?.data?.application_id,
        form: form ?? undefined,
      };
      datadogLogs.logger.error("Error while creating submission to form.io", { data: data }, error);
      throw error; // don't let datadog logging stop error from propagating to downstream handlers
    }
  },

  async getSubmissionReport(payload) {
    return (await getApiClient().post("/forms/submission-report", payload)).data;
  },

  async getApplicationsSubmission(payload) {
    return (await getApiClient().post("/application/exists", payload))?.data ?? {};
  },

  async createOrUpdateSubmission(form, payload, id) {
    if (id) {
      return this.updateSubmission(form, id, payload);
    }

    return this.createSubmission(form, payload);
  },
};

export default formService;
